import React from 'react';
import CustomIcon from 'components/customIcon';
import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import Show from 'components/Show';

const SyncItem = ({ icon, title, description, disabled, onClick, loading, id }) => {
    return (
        <Styled className={`card-container ${disabled ? 'disabled' : ''}`} onClick={onClick}>
            <div className="icon-container">
                <CustomIcon icon={icon} style={{ fontSize: 24 }} />
            </div>
            <div className="text-container">
                <div className="title">{title}</div>
                <div className="description">{description}</div>
            </div>
            <div className="loading-container">
                <Show when={loading === id}>
                    <CircularProgress size={30} />
                </Show>
            </div>
        </Styled>
    );
};

const Styled = styled.div`
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;

    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .icon-container {
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .text-container {
        flex: 1;
        display: flex;
        flex-direction: column;

        .title {
            font-weight: 500;
            font-size: 16px;
            margin-bottom: 5px;
        }

        .description {
            color: #8c8c8c;
            font-size: 14px;
        }
    }
`;
export default SyncItem;
